module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_9016.3d444994.png";